import type {
  FileResponse,
  UploadUrlRequest,
  UploadUrlResponse,
} from '../interfaces/file.interface'
import { agentsApiSlice } from './agents-api.store'

const FILES_API = '/api/v1/files'

const fileAgentsEndpoints = agentsApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    requestUploadUrl: builder.mutation<UploadUrlResponse, UploadUrlRequest>({
      query: (body) => ({
        url: `${FILES_API}/upload-url`,
        method: 'POST',
        body,
      }),
    }),

    confirmFileUpload: builder.mutation<FileResponse, string>({
      query: (fileId) => ({
        url: `${FILES_API}/${fileId}/confirm`,
        method: 'POST',
      }),
    }),

    getFile: builder.query<FileResponse, string>({
      query: (fileId) => `${FILES_API}/${fileId}`,
    }),
  }),
})

export const {
  useRequestUploadUrlMutation,
  useConfirmFileUploadMutation,
  useGetFileQuery,
  useLazyGetFileQuery,
} = fileAgentsEndpoints
